const uEmoji = {
  hi1: "upgrade-images/120px/smile-hi.webp",
  hi2: "upgrade-images/120px/smile-hi2.webp",
  no1: "upgrade-images/120px/smile-no1.webp",
  no2: "upgrade-images/120px/smile-no2.webp",
  no3: "upgrade-images/120px/smile-no3.webp",
  sleep: "upgrade-images/120px/smile-sleep.webp",
  wait1: "upgrade-images/120px/smile-wait1.webp",
  wait2: "upgrade-images/120px/smile-wait2.webp",
  why: "upgrade-images/120px/smile-why.webp",
  wow: "upgrade-images/120px/smile-wow.webp",
  yes1: "upgrade-images/120px/smile-yes1.webp",
  yes2: "upgrade-images/120px/smile-yes2.webp",
  yes3: "upgrade-images/120px/smile-yes3.webp",
  smile24: "upgrade-images/120px/smile-24.webp",
};
export default uEmoji;
